import { useRef, useState, useEffect } from "react"
import { XIcon, Maximize2, Minimize2 } from "lucide-react"

const IframeModal = ({ setIsLinkOpen, isIframeLoading, linkContent, setIsIframeLoading }) => {
  const iframeRef = useRef(null)
  const [isFullscreen, setIsFullscreen] = useState(false)

  // Handle escape key to exit fullscreen
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && isFullscreen) {
        setIsFullscreen(false)
      }
    }
    window.addEventListener("keydown", handleEsc)
    return () => window.removeEventListener("keydown", handleEsc)
  }, [isFullscreen])

  // Toggle fullscreen mode
  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen)
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50 backdrop-blur-sm">
      <div
        className={`relative flex flex-col bg-white rounded-lg shadow-2xl overflow-hidden transition-all duration-300 ${
          isFullscreen
            ? "w-full h-full max-w-none m-0 rounded-none"
            : "w-full h-full max-w-4xl mx-4 sm:mx-auto sm:h-auto max-h-[90vh]"
        }`}
      >
        <div className="flex justify-between items-center p-3 border-b bg-gray-50">
          <h3 className="font-medium text-lg truncate pr-2">{linkContent.title || "External Content"}</h3>
          <div className="flex items-center gap-1">
            <button
              onClick={toggleFullscreen}
              className="p-2 rounded-full hover:bg-gray-200 transition-colors duration-200"
              aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
            >
              {isFullscreen ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
            </button>
            <button
              onClick={() => setIsLinkOpen(false)}
              className="p-2 rounded-full hover:bg-gray-200 transition-colors duration-200"
              aria-label="Close modal"
            >
              <XIcon size={18} />
            </button>
          </div>
        </div>

        <div className="relative w-full flex-1 overflow-hidden">
          {isIframeLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-white/80 z-10">
              <div className="w-12 h-12 relative">
                <div className="absolute top-0 left-0 w-full h-full border-4 border-gray-200 rounded-full"></div>
                <div className="absolute top-0 left-0 w-full h-full border-4 border-t-primary border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin"></div>
              </div>
            </div>
          )}

          <iframe
            ref={iframeRef}
            src={linkContent.url}
            title={linkContent.title || "External Content"}
            className="w-full h-full border-0"
            onLoad={() => setIsIframeLoading(false)}
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            loading="lazy"
            style={{ height: "100%", minHeight: isFullscreen ? "100vh" : "500px" }}
          />
        </div>
      </div>
    </div>
  )
}

export default IframeModal

